export default "__VITE_ASSET__CbKfntXN__"